import React, { FC, useEffect } from 'react';

import { ymOther } from '~/feature/yandex/YandexMetrikaInit';

export interface AddAuthorMetricaProps {
  metrikaId?: number | string;
}

export const AddAuthorMetrika: FC<AddAuthorMetricaProps> = ({ metrikaId }) => {
  useEffect(() => {
    if (metrikaId) {
      ymOther(Number(metrikaId), 'init', { ecommerce: 'dataLayer' });
    }
  }, [metrikaId]);

  return (
    <></>
  );
};
